import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';

export const setAltchaToken = createAction(
  `${reduxKey}.ALTCHA_SET_TOKEN`,
  (verificationToken: string | undefined) => ({ verificationToken })
);

export const clearAltchaToken = createAction(
  `${reduxKey}.ALTCHA_CLEAR_TOKEN`,
  () => ({})
);

export const setAltchaWithMsgToken = createAction(
  `${reduxKey}.ALTCHA_SET_WITH_MSG_TOKEN`,
  (withMsgToken: string | undefined) => ({ withMsgToken })
);

export const clearAltchaWithMsgToken = createAction(
  `${reduxKey}.ALTCHA_CLEAR_WITH_MSG_TOKEN`,
  () => ({})
);

export const setAltchaWithoutMsgToken = createAction(
  `${reduxKey}.ALTCHA_SET_WITHOUT_MSG_TOKEN`,
  (withoutMsgToken: string | undefined) => ({ withoutMsgToken })
);

export const clearAltchaWithoutMsgToken = createAction(
  `${reduxKey}.ALTCHA_CLEAR_WITHOUT_MSG_TOKEN`,
  () => ({})
);
